import { AccordionSection } from 'components/Accordion';
import { Text } from 'components/Text';
import { getLocaleLanguage, getTrans } from 'modules/i18n';
import { desktopImages, getDesktopInstructions } from '../constants';
import { Instructions } from './Instructions';
import { SizedBox } from './SizedBox';

export const DesktopInstructions = () => {
  const localeLanguage = getLocaleLanguage();

  const desktopInstructions = getDesktopInstructions();

  return (
    <AccordionSection
      title={getTrans('geolocationSettingsPage.instructions.browser.title')}
    >
      <Instructions
        instructions={desktopInstructions}
        images={desktopImages[localeLanguage]}
      />

      <SizedBox>
        <Text variant="body2" mt={1}>
          <b>{getTrans('geolocationSettingsPage.instructions.final.part1')}</b>
          &nbsp;
          {getTrans('geolocationSettingsPage.instructions.final.part2')}
        </Text>
      </SizedBox>
    </AccordionSection>
  );
};
